export const CHANGE_LANGUAGE = "@multiLanguage/change-language";

export function changeLanguage(languageCode) {
  return (dispatch) =>
    dispatch({
      type: CHANGE_LANGUAGE,
      payload: {
        languageCode
      }
    });
}
